import React from "react";
import { observable } from "mobx";
import { startOfMonth, subDays, max } from "date-fns";
import { Formatter } from "libs";
import * as Api from "api";
import * as RetentionReport from "api/agencies/RetentionReport";

export class Store {
  @observable.ref
  public loading = false;

  @observable.ref
  public startAt = startOfMonth(new Date());

  @observable.ref
  public endAt = max([subDays(new Date(), 1), startOfMonth(new Date())]);

  @observable.ref
  public retentionReports: RetentionReport.IndexResponse[] = [];

  public async fetchRetentionReports(agencyId: number, appId: number) {
    this.loading = true;

    const response = await RetentionReport.Api.index(agencyId, {
      appId,
      startAt: Formatter.date(this.startAt),
      endAt: Formatter.date(this.endAt),
    });

    if (response?.status === Api.Status.OK) {
      this.retentionReports = response.data;
    }

    this.loading = false;
  }
}

const Context = React.createContext<Store | null>(null);

export const StoreProvider: React.FC<{ value?: Store }> = ({
  children,
  value,
}) => {
  const store = React.useMemo(() => (value ? value : new Store()), [value]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useStore = () => {
  const store = React.useContext(Context);
  if (!store) {
    throw new Error("useStore must be used within a StoreProvider.");
  }
  return store;
};
